export async function registerUser(credentials: {password: string, email: string, phone_number: string, name: string}) {
    return fetch('https://phplaravel-930928-3230982.cloudwaysapps.com/api/register', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    })
        .then(data => data.json())
}